Wee.fn.make('accordion', {
	init: function() {
		$('ref:accordionToggle').on('click.accordion', function(e, el) {
			var content = $('ref:id-' + $(el).data('id'));

			content.isSelected() ? content.unselect() : content.select();
		});
	},

	/**
	 * Unload accordion
	 */
	unload: function() {
		$.events.off(false, 'click.accordion');
	}
});